import makeStyles from "@mui/styles/makeStyles";
import { getFlagPosition } from "./Flag.helpers";
import { FlagProps } from "./Flag.types";
import flags from "./sprites/flags-64.png";

export const useStyles = makeStyles(() => ({
  root: (props: FlagProps) => ({
    display: "inline-block",
    position: "relative",
    width: props.size,
    height: props.size,
    verticalAlign: "middle",
    "&::before": {
      display: "block",
      content: "''",
      position: "absolute",
      top: props.size / 2 - 32,
      left: props.size / 2 - 32,
      width: 64,
      height: 64,
      backgroundImage: `url(${flags})`,
      backgroundPosition: getFlagPosition(props.code),
      transform: `scale(${props.size / 64})`,
    },
  }),
}));
